import { withProps } from "recompose";
import trackEvent from "theme/modules/Analytics/trackEvent";

const trackProductRemoved = (
  cart_id,
  sku,
  name,
  price,
  currency,
  quantity,
  image_url
) =>
  trackEvent("Product Removed", {
    cart_id,
    sku,
    name,
    price,
    quantity,
    image_url,
    currency,
  });

const withPostMutationProductRemovedTracking = () =>
  withProps((props) => ({
    onProductRemoved: ({ status, data }) => {
      if (status === "success") {
        const price = props.item?.priceInfo?.price?.priceInclTax;

        trackProductRemoved(
          props.cart_id,
          props.sku,
          props.name,
          price?.amount,
          price?.currency,
          props.quantity,
          props.imageUrl
        );
      }
    },
  }));

export default withPostMutationProductRemovedTracking;
